import { render, staticRenderFns } from "./PurL_List.vue?vue&type=template&id=47739e79"
import script from "./PurL_List.vue?vue&type=script&lang=js"
export * from "./PurL_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports